export function getStaticUrl(path: string): string {
  if (
    process.env.ENVIRONMENT === 'staging' ||
    process.env.ENVIRONMENT === 'devserver' ||
    process.env.NODE_ENV === 'development'
  ) {
    return path
  }

  return `https://static-cz.car.gr${path}`
}
